import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  private http = inject(HttpClient);
  environment = environment;

  constructor() { }

  /**
   * Guarda el token en las cookies.
   * @param name nombre de la cookie a guardar
   * @param value valor de la cookie a guardar
   * @param days duración en dias de la cookie
   * @param domain dominio de las cookies
   */
  saveToken(name: string, value: string, date: Date): void {
    // const appDomain = '.dev-app-local.com';
    const appDomain = this.getDomain();
    // const domainOption = appDomain ? `; domain=${appDomain}` : '';
    const expires = `expires=${date.toUTCString()}`;
    try {
      document.cookie = `${name}=${value}; ${expires}; path=/; domain=${appDomain}; Secure; SameSite=Strict`;
    } catch (error) {
      console.log(`%c * error *`, 'color:red', error)

    }
  }


  /**
   * Retrieves the domain based on the application's environment configuration.
   *
   * @returns {string} The domain string. If the domain includes '127.0.0.1',
   * it returns '127.0.0.1'. If it includes 'dev-app-local.com', it returns
   * '.dev-app-local.com'. Otherwise, it defaults to '.edutin.com'.
   */
  getDomain() {
    const domain: string = environment.appDomain;
    if (domain.includes('127.0.0.1')) {
      return '127.0.0.1';
    }
    if (domain.includes('dev-app-local.com')) {
      return '.dev-app-local.com';
    }
    return ".edutin.com";
  }


  /**
   * Obtiene el token almacenado.
   * @returns El token o null si no está definido.
   */
  getToken(): string | null {
    const token = this.getCookie('accessToken');
    return token;
  }
  getRefreshToken(): string | null {
    const token = this.getCookie('refreshToken');
    return token;
  }


  getCookie(name: string): string | null {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return null;
  }

  /**
   * Elimina el token del almacenamiento local.
   */
  clearCookie(name: string, domain?: string): void {
    const date = new Date();
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000)); //
    this.saveToken(name, '', date); // Establece el tiempo de expiración en el pasado
  }

  /**
   * Verifica si el token es válido comprobando su formato o expiración.
   * @returns true si el token es válido, false en caso contrario.
   */
  isTokenValid(): boolean {
    if (!this.getToken()) {
      return false;
    }


    const payload = this.getDecodedToken();

    if (!payload || !payload.exp) {
      return false;
    }

    //Si el token ya venció es inválido
    const currentTime = Math.floor(Date.now() / 1000); // Tiempo actual en segundos
    return payload.exp > currentTime;
  }

  /**
   * Decodifica el token JWT para extraer su payload.
   * @param token El token a decodificar
   * @returns El payload del token o null si el formato no es válido.
   */

  getDecodedToken(): any {
    const token = this.getToken();
    if (!token) return;
    // const payload = token.split('.')[1];
    return jwtDecode(token);
  }

}
